import { Reducer, Action } from "redux";

export function combineReducersPartial<TState extends object>(
    reducerMap: { [P in keyof TState]?: Reducer<TState[P]> },
    defaultState?: TState
): Reducer<TState> {
    return (state: TState = defaultState, action: Action): TState => {
        return Object.keys(reducerMap).reduce((result: TState, key) => {
            const reducer = reducerMap[key];

            if (reducer) {
                const reducedPropValue = reducer(result[key], action);
                if (reducedPropValue !== result[key]) {
                    return {
                        ...(result as any),
                        [key]: reducedPropValue
                    };
                }
            }

            return result;
        }, state);
    };
}
